import { createSelector } from 'reselect';
import { getEnv } from 'services/env-service';

export const getState = state => state.auth;

export const getIsUserLoggedIn = createSelector(
  getState,
  state => state.isLoggedIn,
);

export const getError = createSelector(
  getState,
  state => state.error,
);

export const getUserHasPassed2FA = createSelector(
  getState,
  state => {
    const twoFAEnabled = getEnv('REACT_APP_TWO_FA_ENABLED', {
      isBoolean: true,
    });
    return twoFAEnabled ? state.hasPassed2FA : true;
  },
);

export const getUserHasPassedPasswordAuth = createSelector(
  getState,
  state => state.hasPassedPasswordAuth,
);

export const getIsLoading = createSelector(
  getState,
  state => state.isFetching,
);

export const getSessionId = createSelector(
  getState,
  state => state.sessionId,
);

export const getUserDetails = createSelector(
  getState,
  state => state.user,
);

export const getUserPermissions = createSelector(
  getState,
  state => state.user.permissions,
);
